import styled from "styled-components";

export const ModalBody = styled.form`
	display: flex;
	flex-direction: column;
	gap: 32px;
`;

export const Title = styled.p`
	font-size: 14px;
	line-height: 23px;
	color: #31475a;
`;

export const RowContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 32px;
`;

export const CheckboxContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;

	span {
		font-size: 14px;
		line-height: 23px;
		color: #31475a;
	}
`;
